import { render, staticRenderFns } from "./ManageStaffLeaves.vue?vue&type=template&id=ed434e64&scoped=true&"
import script from "./ManageStaffLeaves.vue?vue&type=script&lang=js&"
export * from "./ManageStaffLeaves.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed434e64",
  null
  
)

export default component.exports